<template>
  <span
    class="base-badge"
    :class="{
      [`base-badge--${variant}`]: variant !== 'outline',
      'base-badge--bold': bold,
      'font-s-copy': size === 'sm',
    }"
  >
    <i v-if="icon" class="base-badge__icon icon" :class="[icon]" aria-hidden="true"></i>
    <slot />
  </span>
</template>

<script setup>
defineProps({
  variant: {
    type: String,
    default: 'outline',
    validator: (value) => ['pill', 'outline', 'filled'].includes(value),
  },
  icon: {
    type: String,
    default: '',
  },
  bold: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md'].includes(value),
  },
});
</script>

<style lang="scss">
@import './scss/BaseBadge.scss';
</style>
